import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Opens a Bootstrap modal as soon as it is on the page - accounts/my_account's "save this card?"
// prompt after a Stripe checkout.
//
// This used to be an inline <script>, which only runs on a full page load: the CSP nonce is new on
// every response, and on a Turbo navigation Turbo stamps the new page's nonce onto the scripts it
// runs, which the document's original policy refuses. A controller in the application pack runs
// however the page was reached.
export default class extends Controller {
  connect() {
    // Not on the cached copy Turbo flashes up before the real page arrives.
    if (document.documentElement.hasAttribute('data-turbo-preview')) return

    Modal.getOrCreateInstance(this.element).show()
  }
}
